import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Label } from "@cars24/turbo-web/lib/label";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import Question from "../../shared/images/question.svg";
import { ChevronIcon } from "@cars24/turbo-web/lib/icons/chevron-icon";
import LazyImage from "../../shared/lazy-image";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { pdiWhatIsInspection } from "../../../constants/tracking-constants/pre-delivery-inspection";

const PreDeliveryInspectionReason = ({
    details
}) => {

    const {
        title: deliveryTitle = "",
        sectionData: deliveryList = []
    } = details || {};

    const { tokens } = useTokens();

    const handleScroll = async () => {
        const targetElement = document.getElementById("why-pre-delivery-inspection");
        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            await yieldToMain();
            sendCustomGaEvents(pdiWhatIsInspection);
        }
    };

    const renderList = () => {
        return deliveryList.length > 0 && deliveryList.map((item, index) =>
            (<div key={index} styleName={"styles.insReasonCard"}>
                <div styleName={"styles.cardImg"}>
                    <LazyImage src={item.image.url} alt={item.title} />
                </div>
                <div styleName={"styles.reasonContent"}>
                    <Label level={3} fontWeight="semibold" color={tokens.text_default_text_primary}>{item.title}</Label>
                    <BodyText level={3} color={tokens.text_default_text_secondary}>
                        <span>{item.subTitle}{" "}</span>{item.description}
                    </BodyText>
                </div>
            </div>)
        );
    };

    return (
        <div styleName={"styles.reasonsWrapper"}>
            <Heading level={2} isBold color={tokens.text_default_text_primary}>{deliveryTitle}</Heading>
            <div styleName={"styles.reasonsItems"}>
                {renderList()}
            </div>
            <div styleName={"styles.whatIsInspection"}>
                <LazyImage src={Question} />
                <div styleName={"styles.whatIsInspectionArrowWrapper"} onClick={handleScroll}>
                    <Heading isBold level={3} color={tokens.text_default_text_primary}>What is pre-delivery inspection?</Heading>
                    <ChevronIcon rotateBy={270} size={16} />
                </div>
            </div>
        </div>
    );
};

PreDeliveryInspectionReason.propTypes = {
    details: PropTypes.object
};

export default PreDeliveryInspectionReason;
